"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgWifiOff = function SvgWifiOff(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M13.707 12.293l9.094 9.092c.053.042.101.09.145.143l12.761 12.765a1 1 0 01-1.414 1.414l-6.618-6.616c-.26.052-.54 0-.774-.166a5 5 0 00-5.792 0 1 1 0 01-1.158-1.63 6.995 6.995 0 014.662-1.267l-2.781-2.782a9.94 9.94 0 00-4.19 2.071 1 1 0 11-1.283-1.534 11.94 11.94 0 013.852-2.157l-2.323-2.324a14.91 14.91 0 00-3.806 2.447 1 1 0 11-1.324-1.498 16.91 16.91 0 013.627-2.45l-4.092-4.094a1 1 0 011.414-1.414zM29.16 22.16c.894.437 1.73.983 2.488 1.627a1 1 0 11-1.294 1.524 9.94 9.94 0 00-2.072-1.353 1 1 0 01.878-1.798zm6.083-1.91a1 1 0 11-1.324 1.499 15 15 0 00-11.128-3.703 1 1 0 11-.16-1.994 17 17 0 0112.612 4.197z",
    id: "wifi-off_svg__a"
  }));
};

var _default = SvgWifiOff;
exports["default"] = _default;